export function generateCacheKey(method, url, params = null, body = null) {
    const normalizedMethod = method.toUpperCase();
    let normalizedUrl = url;

    if (normalizedUrl.includes('?')) {
        normalizedUrl = normalizedUrl.split('?')[0];
    }

    if (normalizedUrl.startsWith(import.meta.env.VITE_API_BASE_URL)) {
        normalizedUrl = normalizedUrl.replace(import.meta.env.VITE_API_BASE_URL, '');
    }

    let key = `${normalizedMethod}:${normalizedUrl}`;

    if (params && Object.keys(params).length > 0) {
        const sortedParams = Object.keys(params)
            .sort()
            .map((key) => `${key}=${JSON.stringify(params[key])}`)
            .join('&');
        key += `?${sortedParams}`;
    }

    if (body && Object.keys(body).length > 0) {
        const sortedBody = Object.keys(body)
            .sort()
            .map((key) => `${key}:${JSON.stringify(body[key])}`)
            .join(',');
        key += `:${sortedBody}`;
    }

    return key;
}

export function shouldCacheRequest(method, url, requestConfig = {}, cacheConfig = null) {
    if (requestConfig.skipCache || requestConfig.forceRefresh) {
        return false;
    }

    const normalizedMethod = method.toUpperCase();

    if (normalizedMethod === 'GET') {
        return false;
    }

    if (normalizedMethod === 'POST') {
        if (!cacheConfig?.cachePOST) {
            return false;
        }

        const cacheableEndpoints = cacheConfig?.cachePOSTEndpoints ?? [];
        return cacheableEndpoints.some((endpoint) => url.includes(endpoint));
    }

    return false;
}
